import { Select } from 'react-daisyui';

const { Option } = Select;

// Minimal shape the dropdown needs. `qbo_transactions` is optional so it works
// both with the transactions list (which loads it, to show a count) and with
// plain company lists (e.g. /getClientCompanies) that don't.
interface SelectableCompany {
  id?: number;
  name: string;
  qbo_transactions?: unknown[];
}

interface Props {
  companies: SelectableCompany[];
  selectedId?: number;
  onSelect: (companyId: number) => void;
  // When set, an empty default option is shown first (value 0). Lets callers
  // start with nothing selected so picking any company fires onChange — even the
  // one that would otherwise be the browser's default first option.
  placeholder?: string;
}

/** Dropdown company selector; compact and scales to many companies. */
export function CompanySelectorDropdown({
  companies,
  selectedId,
  onSelect,
  placeholder,
}: Props) {
  // Build a single options array — react-daisyui's Select rejects mixed/null
  // children, so we can't inline a conditional placeholder element.
  const options = companies.map((c) => {
    const count = c.qbo_transactions?.length;
    return (
      <Option key={`opt-${c.id as number}`} value={c.id as number}>
        {count != null ? `${c.name} · ${count}` : c.name}
      </Option>
    );
  });
  if (placeholder) {
    options.unshift(
      <Option key='opt-placeholder' value={0}>
        {placeholder}
      </Option>
    );
  }

  return (
    <div className='flex items-center' data-testid='company-selector-dropdown'>
      <span className='mr-2'>Company</span>
      <Select
        size='sm'
        value={selectedId ?? 0}
        onChange={(v: number) => onSelect(Number(v))}
      >
        {options}
      </Select>
    </div>
  );
}
